import { ref } from 'vue';
import { injectable } from 'inversify';

import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { ConvergingTask } from '@/platform/ConvergingTask';
import { EventAggregationService } from '@/platform/EventAggregationService';
import { IndexableUrlRefreshCompletedEvent } from '@/platform/events/IndexableUrlRefreshCompletedEvent';
import { SearchResultsReadyEvent } from '@/platform/events/SearchResultsReadyEvent';
import { Indexability } from '@/seo/Indexability';


@injectable()
export class IndexableUrl extends ConvergingTask<boolean, null> implements ISubscriber<SearchResultsReadyEvent> {

	public readonly isIndexable = ref(false);
	private disposed = false;

	private readonly indexability: Indexability;
	private readonly eventAggregationService: EventAggregationService;

	public constructor(
		eventAggregationService: EventAggregationService,
		indexability: Indexability
	) {
		super();

		this.indexability = indexability;
		this.eventAggregationService = eventAggregationService;

		eventAggregationService.subscribeTo(SearchResultsReadyEvent.EventType, this);
	}

	public async notify(event: SearchResultsReadyEvent): Promise<void> {
		if (this.disposed) return;

		if (SearchResultsReadyEvent.is(event)) {
			await this.refresh();
		}
	}

	private async refresh(): Promise<void> {

		await this.execute(null);
	}

	protected override async run(): Promise<boolean> {
		return await this.indexability.shouldIndex();
	}

	protected override commit(result: boolean): void {
		this.isIndexable.value = result;
	}

	protected override afterEachRun(): void {

		this.eventAggregationService.publishTo(
			IndexableUrlRefreshCompletedEvent.EventType,
			new IndexableUrlRefreshCompletedEvent(this.isIndexable.value)
		)
	}

	public dispose(): void {
		this.disposed = true;
	}
}
